import React, { PureComponent } from 'react';
import { Button, FontIcon, DialogContainer } from 'react-md';
import {
  RadialBarChart,
  RadialBar,
  Legend,
  ResponsiveContainer,
} from 'recharts';
import { trackEvent } from '../../util/analytics';
import './AttackInfoModal.scss';

class AttackInfoModal extends PureComponent {
  state = { visible: false };

  data = [
    { name: '', value: 10, fill: '#FFFFFF' }, // Hidden max-value used to scale other bars
    { name: 'Maliciousness', value: 0, fill: '#B80C09' },
    { name: 'Data Exposure', value: 0, fill: '#183446' },
    { name: 'Chance of Causing Breach', value: 0, fill: '#F6AA1C' },
  ];

  show = () => {
    this.setState({ visible: true });
    trackEvent({
      category: 'Attack Info',
      action: 'Opened',
      label: this.props.title,
    });
  };

  hide = () => {
    this.setState({ visible: false });
    trackEvent({
      category: 'Attack Info',
      action: 'Closed',
      label: this.props.title,
    });
  };

  render() {
    const { visible } = this.state;
    const actions = [
      {
        onClick: this.hide,
        primary: true,
        children: 'OK',
      },
    ];

    if (this.props.riskScoreMalice) {
      this.data[1].value = this.props.riskScoreMalice;
    }
    if (this.props.riskScoreExposure) {
      this.data[2].value = this.props.riskScoreExposure;
    }
    if (this.props.riskScoreBreach) {
      this.data[3].value = this.props.riskScoreBreach;
    }

    return (
      <div>
        <Button onClick={this.show} icon>
          info_outline
        </Button>
        <DialogContainer
          portal
          id={'attack-info-' + this.props.id}
          visible={visible}
          title={this.props.title}
          onHide={this.hide}
          aria-describedby={'attack-info-' + this.props.id + '-description'}
          modal
          actions={actions}
        >
          <div className="dialog-inner">
            <h2>
              <FontIcon>question_answer</FontIcon> How does this happen?
            </h2>
            <p
              id={'attack-info-' + this.props.id + '-description-why'}
              className="md-color--secondary-text"
            >
              {this.props.whyText}
            </p>
          </div>

          <div className="dialog-inner">
            <h2>
              <FontIcon>warning</FontIcon> Risk to your users
            </h2>
            <p
              id={'attack-info-' + this.props.id + '-description-risk'}
              className="md-color--secondary-text"
            >
              {this.props.riskText}
            </p>
            <ResponsiveContainer width="100%" height={120}>
              <RadialBarChart
                cx="35%"
                cy="100%"
                innerRadius={25}
                outerRadius={130}
                startAngle={180}
                endAngle={0}
                barSize={23}
                data={this.data}
              >
                <RadialBar
                  minAngle={15}
                  label={{ fill: '#FFF', position: 'insideStart' }}
                  background
                  clockWise
                  dataKey="value"
                />
                <Legend
                  iconSize={10}
                  width={200}
                  height={80}
                  layout="vertical"
                  verticalAlign="middle"
                  align="right"
                />
              </RadialBarChart>
            </ResponsiveContainer>
          </div>
        </DialogContainer>
      </div>
    );
  }
}

export default AttackInfoModal;



// WEBPACK FOOTER //
// ./src/components/AttackInfoModal/AttackInfoModal.jsx